import React from "react";
import PropTypes from "prop-types";
import { DirectUpload } from "@rails/activestorage";
import Dropzone from "react-dropzone";

class FileInfo extends React.Component {
  render() {
    const { file } = this.props;

    return (
      <div className="attachment">
        <div className="info word-wrap">
          {file.url ? (
            <a href={file.url} className="styled-link" target="_blank">
              {file.name}
            </a>
          ) : (
            file.name
          )}
          {file.size != null && (
            <span className="dark-grey-text">{` (${(file.size / 1024 / 1024).toFixed(1)}MB)`}</span>
          )}
        </div>

        <div className="actions">
          <span
            className="material-icons pointer-hand styled-link icon-in-row"
            style={{ width: 20 }}
            onClick={this.handlerDelete}
          >
            delete
          </span>
        </div>
      </div>
    );
  }

  handlerDelete = () => {
    if (!confirm("Are you sure you want to delete this file?")) {
      return;
    }

    const { index, file, category, onDelete } = this.props;
    onDelete(file.id, index, category);
  };
}

class Attachment extends React.Component {
  render() {
    const { accept, files, category, onDelete, labelId } = this.props;
    const attachmentLabelId = labelId || "control-label";
    const inputProps = { 'aria-labelledby': attachmentLabelId };
    return (
      <div>
        <div className="form-group">
          <label id={attachmentLabelId} className="control-label">Attachment(s)</label>
          <Dropzone
            className="dropzone dq-dropzone"
            acceptClassName="dq-dropzone-accepted"
            rejectClassName="dq-dropzone-rejected"
            accept={accept === "*/*" ? null : accept}
            multiple={true}
            disablePreview={false}
            onDrop={this.handlerDrop}
            inputProps={inputProps}
          >
            <div className="grey-text text-center">
              <br />
              <h4>Drop file's here or click to upload.</h4>
              <br />
            </div>
          </Dropzone>
        </div>

        <div className="form-group">
          <div className="attachments">
            {files.map((file, index) => (
              <FileInfo
                key={index}
                index={index}
                file={file}
                category={category}
                onDelete={onDelete}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }

  handlerDrop = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      toastr.error(
        `File type not supported for ${rejectedFiles
          .map(file => file.name)
          .join(", ")}`
      );
      return;
    }

    const { category, onDropFile } = this.props;
    onDropFile(acceptedFiles, category);
  };
}

Attachment.propTypes = {
  accept: PropTypes.string,
  category: PropTypes.string,
  files: PropTypes.array,
  onDropFile: PropTypes.func,
  onDelete: PropTypes.func
};

Attachment.defaultProps = {
  accept: "application/pdf, image/*",
  category: null,
  files: []
};

export default Attachment;
